export default class ParallaxElement {

    /**
     * @type {HTMLElement}
     */
    element;

    /**
     * @type {HTMLElement}
     */
    child;

    /**
     * @type {DOMRect}
     */
    elementRect;

    /**
     * Parallax value between -1 and 1
     * @type {number} 
     */
    parallaxValue = 0;

    /**
     * @type {boolean}
     */
    hasParent = false;

    /**
     * Raw scroll value
     * @type {number}
     */
    scrollValue = 0;

    /**
     * Smooth scroll value
     * @type {number}
     */
    scrollValueSmooth = 0;

    /**
     * @type {boolean}
     */
    isActive = false;

    /**
     * 
     * @param {HTMLElement} el 
     */
    constructor(el) {
        if (!el) {
            return;
        }

        this.element = el;
        this.elementRect = this.element.getBoundingClientRect();
        this.parallaxValue = Number(this.element.dataset.parallax) || 0;
        this.hasParent = !! this.element.closest('[data-parallax-parent]');
        this.child = this.element.querySelector('[data-parallax-child]');

        if (this.child) {
            this.isActive = true;
        }

        console.log(this);
    }

    /**
     * Update method for external call
     */
    update() {
        if (!this.isActive) {
            return;
        }

        if (this.checkParentViewport()) {
            this.setElementRect();
            this.setScrollValue();
        }

        this.setSmoothScrollValue();
        this.applyStyles();
    }

    /**
     * Calculate smooth scroll value
     */
    setSmoothScrollValue() {
        this.scrollValueSmooth += (this.scrollValue - this.scrollValueSmooth) * 0.1;
    }

    setElementRect() {
        this.elementRect = this.element.getBoundingClientRect();
    }

    /**
     * 
     * @returns {boolean}
     */
    checkParentViewport() {
        if (!this.hasParent) {
            return true;
        }
        
        const parentRect = this.element.closest('[data-parallax-parent]').getBoundingClientRect();
        const offset = 300;

        return parentRect.top < window.innerHeight + offset && parentRect.top + parentRect.height > -offset;
    }

    /**
     * Calculate top value where 0 - center of screen
     */
    setScrollValue() {
        const elTop = this.elementRect.top;// - window.innerHeight * 0.5 - this.elementRect.height * 0.5;
        this.scrollValue = elTop * this.parallaxValue;
    }

    /**
     * Apply css to child element
     */
    applyStyles() {
        const roundedValue = +(this.scrollValueSmooth).toFixed(1);
        this.child.style.transform = `translate3d(0, ${roundedValue}px, 0)`;
    }
};
